const checkIdCard = (card) => {
    const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
    return reg.test(card)
}

const checkMobile = (mobile) => {
    const reg = /^\d{11}$/
    return reg.test(mobile)
}

export default {
    checkIdCard,
    checkMobile
}
